"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
const qr_code_styling_1 = __importDefault(require("qr-code-styling"));
const modal_1 = require("../../../../components/ui/modal");
const smlAddr_1 = require("../../../../helpers/smlAddr");
const svg_selector_1 = require("../../../../assets/svg-selector");
const receive_modal_module_css_1 = __importDefault(require("./receive-modal.module.css"));
const ReceiveModal = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const TgObj = sdk_1.default;
    const [isCopiedAddress, setIsCopiedAddress] = (0, react_1.useState)(false);
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        props.setShowReceiveModal(false);
        window.document.body.style.overflow = 'auto';
    };
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (props.showReceiveModal) {
            window.document.body.style.overflow = 'hidden';
        }
        return () => {
            window.document.body.style.overflow = 'auto';
        };
    }, []);
    const qrCode = new qr_code_styling_1.default({
        width: 230,
        height: 230,
        margin: -3,
        type: 'svg',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/512px-Telegram_logo.svg.png',
        qrOptions: {},
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: 0.41,
            margin: 3
        },
        dotsOptions: {
            type: 'extra-rounded',
            color: '#249CCE'
        },
        backgroundOptions: { color: 'transparent' },
        cornersSquareOptions: {
            type: 'dot',
            color: '#249CCE'
        },
        cornersDotOptions: {
            type: 'dot',
            color: '#249CCE'
        }
    });
    (0, react_1.useEffect)(() => {
    }, []);
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            qrCode.append(ref.current);
        }
        qrCode.update({ data: 'ton://transfer/' + props.addressUser });
    }, [props.addressUser, props.showReceiveModal]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: receive_modal_module_css_1.default.wrapper, children: [isCopiedAddress && ((0, jsx_runtime_1.jsx)(de_ui_1.Alert, { type: "important", onClose: () => setIsCopiedAddress(false), icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\uD83D\uDCC3" }), autoCloseTimeout: 1000, position: "top-right", className: receive_modal_module_css_1.default.alert, children: t('settings-modal.address-copied') })), (0, jsx_runtime_1.jsxs)(modal_1.Modal, { isOpen: props.showReceiveModal, onClose: handleCloseModal, isCloseButton: false, className: receive_modal_module_css_1.default.modal, children: [(0, jsx_runtime_1.jsx)("div", { className: receive_modal_module_css_1.default.modalTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: receive_modal_module_css_1.default.modalTopButton, onClick: handleCloseModal, children: t('common.close') }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: receive_modal_module_css_1.default.modalTitle, children: t('receive-modal.receive-title') }), (0, jsx_runtime_1.jsx)("div", { className: receive_modal_module_css_1.default.modalQr, ref: ref }), (0, jsx_runtime_1.jsxs)("div", { className: receive_modal_module_css_1.default.modalAddress, onClick: () => {
                            TgObj.HapticFeedback.impactOccurred('medium');
                            (0, copy_to_clipboard_1.default)(props?.addressUser ?? '');
                            setIsCopiedAddress(true);
                        }, children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "dot" }), (0, jsx_runtime_1.jsx)(de_ui_1.Title, { className: receive_modal_module_css_1.default.modalAddressTitle, variant: "h2", children: (0, smlAddr_1.smlAddr)(props.addressUser) }), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "copy" })] }), (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: receive_modal_module_css_1.default.modalDescription, children: [t('receive-modal.receive-title'), " ", ' ', (0, jsx_runtime_1.jsx)("span", { children: t('receive-modal.ton-or-jettons') }), ' ', t('receive-modal.via'), " ", ' ', (0, jsx_runtime_1.jsx)("span", { children: t('receive-modal.the-open-network') }), ' ', t('receive-modal.to-this-address'), ' ', (0, jsx_runtime_1.jsx)("span", { children: t('receive-modal.ton-or-jetton') }), ' ', t('receive-modal.or-more-deposit')] }), (0, jsx_runtime_1.jsx)("div", { className: receive_modal_module_css_1.default.background })] })] }));
};
exports.ReceiveModal = ReceiveModal;
